/// <amd-module name="Feed/Legacy/Utils/CopyToClipboard" />
export function copyToClipboard(text: string) {
    const listener = (e: ClipboardEvent) => {
        e.clipboardData.setData("text/plain", text);
        e.preventDefault();
    };
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
}
